import React, { useState } from "react";
import "./finance.scss";
import Header from "../common/Header/header";
import { Modal, Pagination } from "antd";

const FinanceComponent = () => {
  const [requests, setRequests] = useState(
    Array.from({ length: 20 }, (_, i) => ({
      id: i + 1,
      name: `Resident ${i + 1}`,
      flat: `B-${100 + i}`,
      amount: 1500 + i * 100,
      reason: "Monthly Maintenance",
      status: "pending",
    }))
  );

  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 4;

  const [modalVisible, setModalVisible] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [actionType, setActionType] = useState("");

  const handleActionClick = (req, action) => {
    setSelectedRequest(req);
    setActionType(action);
    setModalVisible(true);
  };

  const handleConfirmAction = () => {
    if (selectedRequest) {
      setRequests((prev) =>
        prev.map((req) =>
          req.id === selectedRequest.id ? { ...req, status: actionType } : req
        )
      );
    }
    setModalVisible(false);
    setSelectedRequest(null);
    setActionType("");
  };

  const currentData = requests.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  return (
    <div className="finance-main">
      <Header title="Finance" />
      <div className="approval-section">
        <h2>Maintenance Plan Approval Requests</h2>
        <div className="request-list">
          {currentData.map((req) => (
            <div key={req.id} className={`request-card ${req.status}`}>
              <div className="info">
                <p><strong>Name:</strong> {req.name}</p>
                <p><strong>Flat:</strong> {req.flat}</p>
                <p><strong>Amount:</strong> ₹{req.amount}</p>
                <p><strong>Reason:</strong> {req.reason}</p>
              </div>
              <div className="actions">
                {req.status === "pending" ? (
                  <>
                    <button
                      className="btn approve"
                      onClick={() => handleActionClick(req, "approved")}
                    >
                      Approve
                    </button>
                    <button
                      className="btn decline"
                      onClick={() => handleActionClick(req, "declined")}
                    >
                      Decline
                    </button>
                  </>
                ) : (
                  <p className={`status ${req.status}`}>
                    {req.status.charAt(0).toUpperCase() + req.status.slice(1)}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
        <div className="pagination-container">
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={requests.length}
            onChange={(page) => setCurrentPage(page)}
            showSizeChanger={false}
          />
        </div>
      </div>

      <Modal
        title="Confirm Action"
        open={modalVisible}
        onOk={handleConfirmAction}
        onCancel={() => setModalVisible(false)}
        okText={actionType === "approved" ? "Approve" : "Decline"}
        okButtonProps={{ style: { backgroundColor: "#d6ad61", borderColor: "#d6ad61" } }}
      >
        <p>
          Are you sure you want to{" "}
          <strong>{actionType}</strong> request for{" "}
          <strong>{selectedRequest?.name}</strong>?
        </p>
      </Modal>
    </div>
  );
};

export default FinanceComponent;
